import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Box, Center, Flex, Image } from '@chakra-ui/react'
import { Scrollbars } from 'react-custom-scrollbars-2'

import { authSelector } from '@/stores/auth/authSlice'
import { FaEdit } from 'react-icons/fa'
import SidebarSection from './components/SidebarSection'

import {
  adminConfigSection,
  applicationSection,
  dashboardSection,
  getAdminSection,
  getAdminVendorSection,
  getOfferSection,
  getSourcingOfferSection,
} from './sidebarData'

import { ContributorGroupType } from '@/features/contributorGroups/constants'

import { ConfigType } from '@/features/configs/config.enum'
import { UserEditRight } from '@/features/users/constants'

import useConfig from '@/features/configs/useConfig'
import { TableType } from '@/features/tableProfiles/tableProfile.enum'
import useUserTableProfile from '@/features/userTableProfiles/useUserTableProfile'

const Sidebar = ({ show = true }) => {
  const { user } = useSelector(authSelector)

  const [sidebarData, setSidebarData] = useState([])
  const [homeLink, setHomeLink] = useState('/offers')

  const { useFetchConfigByType } = useConfig()
  const { useGetMyTableProfiles } = useUserTableProfile()

  const { data: maintenanceViewTeamConfig } = useFetchConfigByType(ConfigType.OFFER_MAINTENANCE_VIEW_TEAM)
  const { data: projectViewTeamConfig } = useFetchConfigByType(ConfigType.OFFER_PROJECT_VIEW_TEAM)
  const { data: userTableProfileResponse } = useGetMyTableProfiles(TableType.OFFERS_LIST)

  const { data: sourcingTableProfileResponse } = useGetMyTableProfiles(TableType.SOURCING_OFFER_LIST)

  useEffect(() => {
    const sidebar = []
    const profiles = userTableProfileResponse?.data?.profiles || []

    const profilesShownInSidebar = profiles.filter(
      (profile) =>
        Array.isArray(userTableProfileResponse?.data?.profilesShownInSidebar) &&
        userTableProfileResponse?.data?.profilesShownInSidebar.includes(profile._id)
    )

    const sourcingProfiles = sourcingTableProfileResponse?.data?.profiles || []

    const sourcingProfileShownInSidebar = sourcingProfiles.filter(
      (profile) =>
        Array.isArray(sourcingTableProfileResponse?.data?.profilesShownInSidebar) &&
        sourcingTableProfileResponse?.data?.profilesShownInSidebar.includes(profile._id)
    )

    if (user?.role === 'admin') {
      sidebar.push(getAdminSection({ hasCustomer: true, hasUser: true, hasGC: true, hasRest: true }))
      sidebar.push(adminConfigSection)
      sidebar.push(getAdminVendorSection({ hasUser: true, hasRest: true }))
      sidebar.push(
        getOfferSection({
          hasMaintenance: true,
          hasProject: true,
          hasParticipation: true,
          profiles: profilesShownInSidebar,
        })
      )

      sidebar.push(applicationSection)
    } else if (user.contributorGroup === ContributorGroupType.PROCUREMENT_OFFICER) {
      sidebar.push(getAdminVendorSection({ hasUser: true, hasRest: true }))
      sidebar.push(
        getSourcingOfferSection({
          profiles: sourcingProfileShownInSidebar ?? [],
        })
      )
      sidebar.push(applicationSection)

      setHomeLink('/offers/sourcingDecisions')
    } else {
      if (user.editRights.length > 0) {
        sidebar.push(
          getAdminSection({
            hasCustomer: user.editRights.includes(UserEditRight.CUSTOMER),
            hasUser: user.editRights.includes(UserEditRight.USER),
            hasGC: user.editRights.includes(UserEditRight.GC),
            hasRest: user.editRights.includes(UserEditRight.MASTER_DATA),
          })
        )

        if (user.editRights.includes(UserEditRight.MASTER_DATA)) {
          sidebar.push(adminConfigSection)
        }
      }

      //Vendor Management Section
      if (user.editRights.includes(UserEditRight.USER) || user.editRights.includes(UserEditRight.MASTER_DATA)) {
        sidebar.push(
          getAdminVendorSection({
            hasUser: user.editRights.includes(UserEditRight.USER),
            hasRest: user.editRights.includes(UserEditRight.MASTER_DATA),
          })
        )
      }
      //Determine Offer Section

      sidebar.push(
        getOfferSection({
          hasMaintenance:
            user.editRights.includes(UserEditRight.WORKFLOW) ||
            maintenanceViewTeamConfig?.value.some((team) => user.departments.includes(team)),
          hasProject:
            user.editRights.includes(UserEditRight.WORKFLOW) ||
            projectViewTeamConfig?.value.some((team) => user.departments.includes(team)),

          profiles: profilesShownInSidebar,
        })
      )

      sidebar.push(applicationSection)
    }
    // sidebar.push(dashboardSection)

    sidebar.push({
      title: 'User Manual',
      defaultOpen: false,
      links: [
        {
          name: 'User Manual',
          path: '/userManual',
          icon: <FaEdit />,
        },
      ],
    })
    setSidebarData(sidebar)
  }, [
    user,
    maintenanceViewTeamConfig?.value,
    projectViewTeamConfig?.value,
    userTableProfileResponse?.data,
    sourcingTableProfileResponse?.data,
  ])

  return (
    <Flex w="256px" bg="teal.500" color="white" direction="column" display={[show ? 'block' : 'none']} height="100%">
      <Center height={'5%'} bg="rgba(0,0,21,.2)" minH="40px">
        {/* <Link to={homeLink}>
        </Link> */}
        <Image w="100px" objectFit="cover" src="https://images.sw.cdn.siemens.com/logo/logo-white.svg" />
      </Center>
      <Box height={'95%'}>
        <Scrollbars autoHide>
          <Flex p={2} direction="column" gap="2">
            {sidebarData.map((row) => {
              return <SidebarSection key={row.title} {...row} />
            })}
          </Flex>
        </Scrollbars>
      </Box>
    </Flex>
  )
}

export default Sidebar
